import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getTrackByFn } from '@y42/angular/util';

export interface Diff {
  filePath: string;
  content1: string;
  content2: string;
  showDiff: boolean;
}
export interface DiffDialogData {
  title: string;
  diffs: Diff[];
}

@Component({
  selector: 'y42-diff-dialog',
  templateUrl: './diff-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiffDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: DiffDialogData,
    private readonly dialogRef: MatDialogRef<DiffDialogComponent>,
  ) {}

  trackByFilePath = getTrackByFn<Diff>('filePath');

  close(): void {
    this.dialogRef.close();
  }
}
